import { Button } from "baseui/button";
import { CreateRelationsCommand, RELATION_TYPE, useCreateRelationMutation } from "../../../services/objects";
import { co2RateModelId, } from "../../Energy/EnergyRates";
import { useState } from 'react'
import SelectRateListModal from "./SelectRateListModal/SelectRateListModal";
import { useIntl } from "react-intl";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { GoLink } from "react-icons/go";
import { useStyletron } from "baseui";


const LinkRate = (props: { rateModelId, id, resourceGroupId, onRateLinked }) => {
    const [isOpen, setIsOpen] = useState(false);


    const [createRelation, createRelationResult] = useCreateRelationMutation();
    useReportMutationState(createRelationResult, () => { setIsOpen(false); props.onRateLinked() });

    const relationType: keyof typeof RELATION_TYPE = props.rateModelId === co2RateModelId ? 'Co2Rate' : 'CostRate';

    const handleSubmit = (item: any) => {
        const cmd: CreateRelationsCommand = {
            fromObjectId: props.id,
            toObjectId: item?.id,
            resourceGroupId: props.resourceGroupId,
            type: relationType
        }
        createRelation(cmd);
    }



    return (
        <>
            <Button shape='circle' kind='primary' onClick={() => setIsOpen(true)} ><GoLink></GoLink></Button>
            {isOpen && <SelectRateListModal isSubmitting={createRelationResult.isLoading} onSubmit={handleSubmit} id={props.id} modelToReference={props.rateModelId} resourceGroupId={props.resourceGroupId} isOpen={isOpen} onClose={() => setIsOpen(false)}></SelectRateListModal>}
        </>
    )
}

export default LinkRate;